if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          modal: this.nextElementSibling.tagName === 'MEDIA-GALLERY-MODAL' ? this.nextElementSibling : null,
          modalTriggers: document.querySelectorAll('.media-gallery-modal__buttons button'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (this.elements.modal) {
          this.elements.modal.addEventListener('click', (event) => {
            if (event.target === this.elements.modal || event.target.closest('.media-gallery-modal__close')) {
              this.closeModal();
            } else if (event.target.closest('.media-gallery-modal__tabs button')) {
              this.switchModalTab(event.target.closest('.media-gallery-modal__tabs button').dataset.target);
            }
          });
        }
        this.elements.modalTriggers.forEach((button) => {
          button.addEventListener('click', this.showModal.bind(this, button.dataset.target));
        });
        if (!this.elements.thumbnails) return;
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      showModal(type) {
        const target = `media-gallery-${type}`;
        this.switchModalTab(target);
        this.elements.modal.classList.add('show');
        document.body.classList.add('overflow-hidden');
      }

      closeModal() {
        this.elements.modal.querySelector(`.active[data-target]`)?.classList.remove('active');
        this.elements.modal.querySelector(`.media-gallery-modal__content > div.show`)?.classList.remove('show');
        this.elements.modal.classList.add('closing');
        this.elements.modal.classList.remove('show');
        document.body.classList.remove('overflow-hidden');
        setTimeout(() => {
          this.elements.modal.classList.remove('closing');
        }, 200);
      }

      switchModalTab(type) {
        this.elements.modal.querySelector(`.active[data-target]`)?.classList.remove('active');
        this.elements.modal.querySelector(`.media-gallery-modal__content > div.show`)?.classList.remove('show');
        console.log(type);
        console.log(this.elements.modal);
        this.elements.modal.querySelector(`[data-target="${type}"]`).classList.add('active');
        this.elements.modal.querySelector(`#${type}`).classList.add('show');
      }

      setActiveMedia(mediaId, prepend) {
        if (mediaId === 'modal-videos' || mediaId === 'modal-images') {
          return this.showModal(mediaId);
        }

        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        // this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

if (!customElements.get('media-gallery-modal')) {
  customElements.define(
    'media-gallery-modal',
    class MediaGalleryModal extends HTMLElement {
      constructor() {
        super();

        this.sliderInitialized = false;
        this.videoItems = this.querySelectorAll('.media-gallery-modal__content-videos-list-item');
        this.playerContainer = this.querySelector('.media-gallery-modal__content-videos-player');
        this.imagesContainer = this.querySelector('.media-gallery-modal__content-images');

        this.init();
      }

      init() {
        if (this.videoItems.length > 0) {
          this.videoItems.forEach(item => {
            item.addEventListener('click', () => {
              this.loadVideoTemplate(item);
            });
          });

          this.loadVideoTemplate(this.videoItems[0]);
        }

        this.loadImagesTemplate();
        this.initSliders();
      }

      initSliders() {
        this.viewer = this.querySelector('[id^="GalleryViewerModal"]');
        this.thumbnails = this.querySelector('[id^="GalleryThumbnailsModal"]');

        this.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        this.sliderInitialized = true;
      }

      onSlideChanged(event) {
        const thumbnail = this.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.viewer.querySelector('[data-media-id]');

        if (!activeMedia) {
          return;
        }

        this.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.thumbnails) {
            const activeThumbnail = this.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.viewer.slider) this.viewer.resetPages();
        }

        this.preventStickyHeader();

        if (!this.thumbnails) return;
        const activeThumbnail = this.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.thumbnails || !thumbnail) return;

        this.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      loadImagesTemplate() {
        const template = this.imagesContainer.querySelector('template');

        if (!template) {
          console.warn('No template found');
          return;
        }

        const content = template.content.cloneNode(true);

        this.imagesContainer.appendChild(content);
      }

      loadVideoTemplate(item) {
        const template = item.querySelector('template');

        if (!template) {
          console.warn('No template found');
          return;
        }

        this.querySelector('.media-gallery-modal__content-videos-list-item.active')?.classList.remove('active');
        item.classList.add('active');

        const content = template.content.cloneNode(true);
        this.playerContainer.innerHTML = '';

        this.playerContainer.appendChild(content);

        const video = this.playerContainer.querySelector('video');

        if (video) {
          video.play().catch(() => {});
          video.pause();
        }
      }
    }
  );
}